function normalizeAzPhone(raw) {
    if (!raw) return "";

    let digits = String(raw).replace(/\D/g, "");

    if (digits.startsWith("00994")) {
        digits = digits.slice(2);
    }

    if (digits.startsWith("994")) {
        return digits;
    }

    if (digits.startsWith("0")) {
        return "994" + digits.slice(1);
    }

    if (digits.length === 9) {
        return "994" + digits;
    }

    return digits;
}

export function toWaNumber(raw) {
    return normalizeAzPhone(raw);
}

export function toTelNumber(raw) {
    const normalized = normalizeAzPhone(raw);
    return normalized ? `+${normalized}` : "";
}